import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import DashboardView from '../views/DashboardView.vue'
import SendView from '../views/SendView.vue'
import DocumentView from '../views/DocumentView.vue'
import TargetView from '../views/TargetView.vue'
import ReceiversView from '../views/ReceiversView.vue'
import InputView from '@/views/InputView.vue'
import GenerateContent from '@/views/GenerateContent.vue'
import UserDocumentsView from '@/views/UserDocumentView.vue'
import SentDocumentsView from '@/views/SentDocumentsView.vue'
import PostsView from '@/views/PostsView.vue'
import SelectPositionView from '@/views/SelectPositionView.vue'
import ExpirationView from '@/views/ExpirationView.vue'
import SetEmitDataView from '@/views/SetEmitDataView.vue'
import ConfirmView from '@/views/ConfirmView.vue'
import PanelFirmasView from '@/views/PanelFirmasView.vue'
import AgendaView from '@/views/AgendaView.vue'
import NominasView from '@/views/NominasView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView
  },
  {
    path: '/send',
    name: 'send',
    component: SendView
  },
  {
    path: '/selectdocuments',
    name: 'selectdocuments',
    component: DocumentView
  },
  {
    path: '/selecttarget',
    name: 'selecttarget',
    component: TargetView
  },
  {
    path: '/selectreceivers',
    name: 'selectreceivers',
    component: ReceiversView
  },
  {
    path: '/selectinput',
    name: 'selectinput',
    component: InputView
  },
  {
    path: '/generatecontent',
    name: 'generatecontent',
    component: GenerateContent
  },
  {
    path: '/userdocuments',
    name: 'userdocuments',
    component: UserDocumentsView
  },
  {
    path: '/sentdocuments',
    name: 'sentdocuments',
    component: SentDocumentsView
  },
  {
    path: '/posts',
    name: 'posts',
    component: PostsView
  },
  {
    path: '/selectposition',
    name: 'selectposition',
    component: SelectPositionView
  },
  {
    path: '/selectexpdate',
    name: 'selectexpdate',
    component: ExpirationView
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: ConfirmView
  },  
  {
    path: '/selectemit',
    name: 'selectemit',
    component: SetEmitDataView
  },
  {
    path: '/panel-firmas',
    name: 'panelfirmas',
    component: PanelFirmasView
  },
  {
    path: '/agenda',
    name: 'agenda',
    component: AgendaView
  },
  {
    path: '/sendpaybills',
    name: 'sendpaybills',
    component: NominasView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
